import asyncActionTypes from '../actions/types.js';

const initialState = {
  errorMessageCms: null,
  errorMessageCmsFail: null,
  loadingErrorMessage: false,
};

const errorMessage = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.GET_ERROR_MESSAGE.START:
      return {
        ...state,
        loadingErrorMessage: true,
        errorMessageCms: null,
      };
    case asyncActionTypes.GET_ERROR_MESSAGE.SUCCESS:
      return {
        ...state,
        loadingErrorMessage: false,
        errorMessageCms: action.payload,
      };
    case asyncActionTypes.GET_ERROR_MESSAGE.FAIL:
      return {
        ...state,
        loadingErrorMessage: false,
        errorMessageCmsFail: action.payload,
      };
    case asyncActionTypes.GET_ERROR_MESSAGE.DELETE:
      return {
        ...state,
        loadingErrorMessage: false,
        errorMessageCms: '',
      };
    default:
      return state;
  }
};

export default errorMessage;
